import React from 'react'
import { FormattedMessage } from 'react-intl'
import manoLlavesCirculo from '../../assets/img/mano-llaves-circulo.png'

class Funcionamiento extends React.Component {
    render() {
        return (
            <div className="funcionamiento container">
                <div className="funcionamiento__col1">
                    <h2 style={{ wordWrap: 'break-word' }}>
                        <FormattedMessage id="funcionamiento" defaultMessage="Funcionamiento" />
                    </h2>
                    <p>
                        <FormattedMessage id="el_sistema_dispone_de_diferentes_perfiles_de_usuario" defaultMessage="El sistema dispone de diferentes perfiles de usuario" />
                    </p>
                    <div className="columns">
                        <div className="col_1">
                            <p>
                                <FormattedMessage id="administrador_" defaultMessage="Administrador:" />{' '}
                                <FormattedMessage
                                    id="puede_crear_a_todos_los_tipos_de_usuarios_y_gestionar_todas_las_cerraduras"
                                    defaultMessage="puede crear a todos los tipos de usuarios y gestionar todas las cerraduras."
                                />
                            </p>
                            <p>
                                <FormattedMessage id="usuarios_" defaultMessage="Usuario:" />{' '}
                                <FormattedMessage
                                    id="este_perfil_solamente_tendra_acceso_a_una_o_varias_cerraduras_durante_el_tiempo_que_el_administrador_o_gestor_le_haya_permitido_pero_no_podra_enviar_nuevas_invitaciones_a_otros_usuarios_para_que_tambien_puedan_abrir_su_puerta"
                                    defaultMessage="Este perfil solamente tendrá acceso a una o varias cerraduras durante el tiempo que el administrador o gestor le haya permitido, pero no podrá enviar nuevas invitaciones a otros usuarios para que también puedan abrir su puerta."
                                />
                            </p>
                        </div>
                        <div className="col_2">
                            <p>
                                <FormattedMessage id="gestor_" defaultMessage="Gestor:" />{' '}
                                <FormattedMessage
                                    id="un_gestor_podra_crear_diferentes_invitaciones_sobre_las_cerraduras_que_tenga_asignadas_por_ejemplo_un_gestor_podra_controlar_los_accesos_a_todos_sus_apartamentos_de_sus_huespedes"
                                    defaultMessage="Un gestor podrá crear diferentes invitaciones sobre las cerraduras que tenga asignadas. Por ejemplo, un gestor podrá controlar los accesos a todos sus apartamentos de sus huéspedes."
                                />
                            </p>
                            <p>
                                <FormattedMessage id="invitado_" defaultMessage="Invitado:" />{' '}
                                <FormattedMessage
                                    id="se_usa_para_aperturas_esporadicas,_usuarios_que_solamente_tienen_que_entrar_a_la_vivienda_en_alguna_ocasion_determinada"
                                    defaultMessage="Se usa para aperturas esporádicas, usuarios que solamente tienen que entrar a la vivienda en alguna ocasión determinada."
                                />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="funcionamiento__col2">
                    <img alt="manoLlaveCirculo" src={manoLlavesCirculo} />
                </div>
            </div>
        )
    }
}

export default Funcionamiento



// WEBPACK FOOTER //
// ./src/components/home/Funcionamiento.js